var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "risk-statistics" }, [
    _c("div", { staticClass: "stat-card" }, [
      _c("span", { staticClass: "stat-icon sign-icon" }, [
        _c("i", { class: _vm.icons.signUserNum }),
      ]),
      _c("span", { staticClass: "stat-label" }, [_vm._v("签约人数")]),
      _c("strong", { staticClass: "stat-value" }, [
        _vm._v(_vm._s(_vm.data.signUserNum || "暂无")),
      ]),
      _c("span", { staticClass: "stat-unit" }, [_vm._v("人")]),
    ]),
    _c("div", { staticClass: "stat-card warning" }, [
      _c("span", { staticClass: "stat-icon warning-icon" }, [
        _c("i", { class: _vm.icons.alarmUserNum }),
      ]),
      _c("span", { staticClass: "stat-label" }, [_vm._v("预警人数")]),
      _c("strong", { staticClass: "stat-value" }, [
        _vm._v(_vm._s(_vm.data.alarmUserNum || "暂无")),
      ]),
      _c("span", { staticClass: "stat-unit" }, [_vm._v("人")]),
    ]),
    _c("div", { staticClass: "stat-card" }, [
      _c("span", { staticClass: "stat-icon bind-icon" }, [
        _c("i", { class: _vm.icons.alarmBindAccountNum }),
      ]),
      _c("span", { staticClass: "stat-label" }, [
        _vm._v("预警人员绑定用户总数"),
      ]),
      _c("strong", { staticClass: "stat-value" }, [
        _vm._v(_vm._s(_vm.data.alarmBindAccountNum || "暂无")),
      ]),
      _c("span", { staticClass: "stat-unit" }, [_vm._v("个")]),
    ]),
    _c("div", { staticClass: "stat-card success" }, [
      _c("span", { staticClass: "stat-icon cash-icon" }, [
        _c("i", { class: _vm.icons.alarmUserCashAmount }),
      ]),
      _c("span", { staticClass: "stat-label" }, [
        _vm._v("预警人员累计成功提现"),
      ]),
      _c("strong", { staticClass: "stat-value" }, [
        _vm._v(_vm._s(_vm.data.alarmUserCashAmount || "暂无")),
      ]),
    ]),
    _c("div", { staticClass: "stat-card danger" }, [
      _c("span", { staticClass: "stat-icon block-icon" }, [
        _c("i", { class: _vm.icons.riskBlockText }),
      ]),
      _c("span", { staticClass: "stat-label" }, [_vm._v("风控拦截笔数及金额")]),
      _c("strong", { staticClass: "stat-value" }, [
        _vm._v(_vm._s(_vm.data.riskBlockText || "暂无")),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }